/**
 * 心愿清单（默认值）
 * --------------------------------------------------------------
 * 用户的勾选状态存于 localStorage（key: love-xjj.wishes），
 * 启动时自动合并。
 *
 * ⚠️ id 改动会让旧勾选状态失效（按 id 关联）。
 */

/**
 * @typedef {Object} Wish
 * @property {string} id
 * @property {string} text
 * @property {string} icon
 */

/** @type {Wish[]} */
export const defaultWishes = [
  { id: 'w-001', text: '一起去看一次海',             icon: '🌊' },
  { id: 'w-002', text: '一起做一顿完整的饭',          icon: '🍳' },
  { id: 'w-003', text: '一起去看雪',                 icon: '❄️' },
  { id: 'w-004', text: '一起拍一组写真',             icon: '📷' },
  { id: 'w-005', text: '一起养一只小动物',           icon: '🐱' },
  { id: 'w-006', text: '一起跨一次年',               icon: '🎆' },
  { id: 'w-007', text: '一起看一场日出',             icon: '🌅' },
  { id: 'w-008', text: '一起去西藏',                 icon: '🏔️' },
  { id: 'w-009', text: '一起坐一次热气球',           icon: '🎈' },
  { id: 'w-010', text: '一起学一门乐器',             icon: '🎸' },
  { id: 'w-011', text: '一起种一棵树',               icon: '🌳' },
  { id: 'w-012', text: '一起去看一场演唱会',         icon: '🎤' },
]
